import { render, staticRenderFns } from "./Panier.vue?vue&type=template&id=a475117c&scoped=true&"
import script from "./Panier.vue?vue&type=script&lang=js&"
export * from "./Panier.vue?vue&type=script&lang=js&"
import style0 from "./Panier.vue?vue&type=style&index=0&id=a475117c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a475117c",
  null
  
)

export default component.exports